import { ElementRef, NgZone, OnInit, ViewChild, Component } from '@angular/core';
import { } from 'googlemaps';
import { MapsAPILoader } from '@agm/core';
import { FormControl } from '@angular/forms';
import { NewProjects, ProjectDetails } from '../seller';
import { SellerApiService } from '../service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { KitchenService } from '../service/kitchen.service';
import { KitchenSubDisplay } from '../sub-component/kitchenmodal';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { GlobalEventsManager } from '../../app-global-events-manager';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-browserequest',
  templateUrl: './browserequest.component.html',
  styleUrls: ['./browserequest.component.scss']
})
export class BrowserequestComponent implements OnInit {

  isLeftShowHide: boolean;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public indexNum: number;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  @ViewChild('Deletemodal') openDeleteModal: ElementRef;
  newProjects: Array<NewProjects> = [];
  projectDetails: ProjectDetails = new ProjectDetails();
  buyerName: string;
  buyerInfomation: any = {};
  address: any = {
    streetname: '',
    zipcode: '',
    city: '',
    state: ''
  };
  isLeftArrow: boolean;
  isRightArrow: boolean;
  loaderActivate: boolean;
  loaderFullActivate: boolean;
  styles: Array<any> = [];
  currentSellerName: string;
  currentUserId: number;
  currentSellerId: number;
  kitchenDisplay: KitchenSubDisplay;
  projectId: number;
  is_waitingEnable: boolean;
  is_selected_by_buyer: boolean;
  is_gray_pin: boolean;
  is_inside_seller_service_area: boolean;
  is_waiting_button_enabled: boolean;
  redlabelOptions: any = {};
  greenlabelOptions: any = {};
  graylabelOptions: any = {};
  displayitem: string;
  // tslint:disable-next-line:no-inferrable-types
  displayCom: string = 'browse';
  requestmecount: Array<any> = [];
  viewProjectId: number;
  isDefaultTab: string;
  selectedBuyerId: string;

  constructor(private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private sellerService: SellerApiService,
    private cognitoService: CognitoUtil, public kitchenService: KitchenService,
    private route: ActivatedRoute,private router: Router, private globalEventsManager: GlobalEventsManager) { }

  ngOnInit() {
    this.displayitem = 'requestome';
    this.isDefaultTab = 'map';
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    // seller details to display
    if (userDetails != null) {
      this.currentSellerName = userDetails.username;
    }

      // Query Params params['amp;requesttype'] === 'requestme' ||
    this.route.queryParams.subscribe(params => {
      if (params['requesttype'] === 'requestme') {
        this.displayitem = 'requestome';
      } else {
        this.displayitem = 'openrequest';
      }
      // Project Id
      if (params['projectid']) {
        this.viewProjectId = Number(params['projectid']);
      }

      // if (params['amp;projectid']) {
      //   this.viewProjectId = Number(params['amp;projectid']);
      // }
    });


    this.kitchenDisplay = new KitchenSubDisplay();

    this.redlabelOptions = { url: 'assets/images/mapicons/outside-request-mapmarker.png', scaledSize: { height: 50, width: 30 } };
    this.greenlabelOptions = { url: 'assets/images/mapicons/active-mapmarker.png', scaledSize: { height: 50, width: 30 } };
    this.graylabelOptions = { url: 'assets/images/mapicons/orange-map.png', scaledSize: { height: 50, width: 30 } };


    // set google maps defaults
    this.zoom = 12;
    this.latitude = 59.3293;
    this.longitude = 18.0686;

    if (userDetails.username != null) {
      this.sellerService.getProfileDetails(userDetails.username).subscribe(res => {
        if (res != null) {
          this.currentUserId = res.user_id;
          this.currentSellerId = res.seller_id;
        }
      }, err => {
        console.log(err);
      });
    }

    // create search FormControl
    this.searchControl = new FormControl();
    if (this.displayitem === 'requestome') {
      this.getAllRequestmeProject();
      this.getRequestMeCount();
    } else {
      this.getToloadOpenRequestProjects();
      this.getRequestMeCount();
    }

  }

  // get All Request me Projects
  getAllRequestmeProject() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.loaderFullActivate = true;
    this.sellerService.getAllRequestMeProjects(userDetails.username).finally(() => {
      this.loaderFullActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.newProjects = res;
        this.requestmecount = res;
        if (res.length > 0) {
            this.globalEventsManager.showBrowseRequestNotification(true);
        }else {
           this.globalEventsManager.showBrowseRequestNotification(false);
        }
        if (this.viewProjectId != null) {
          this.newProjects.forEach((item, index) => {
            if (item.project_id === this.viewProjectId) {
              this.viewMarkerDetails(item, index);
            }
          });
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // Take a count Request Me
  getRequestMeCount() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    // this.loaderFullActivate = true;
    this.sellerService.getAllRequestMeProjects(userDetails.username).finally(() => {
      // this.loaderFullActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.requestmecount = res;
      }
    }, err => {
      console.log(err);
    });
  }


  // Load the new Projects
  getToloadOpenRequestProjects() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.loaderFullActivate = true;
    this.sellerService.getnewallProjects(userDetails.username).finally(() => {
      this.loaderFullActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.newProjects = res;
        if (this.viewProjectId != null) {
          this.newProjects.forEach((item, index) => {
            if (item.project_id === this.viewProjectId) {
              this.viewMarkerDetails(item, index);
            }
          });
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // change tab for on click item
  onChangeSelectedTab(item) {
    this.displayitem = item;
    if (this.displayitem === 'requestome') {
      this.getAllRequestmeProject();
    } else {
      this.getToloadOpenRequestProjects();
    }
  }


  // View the Marker Details
  viewMarkerDetails(item, index): void {
      this.isLeftShowHide = true;
      if (item != null) {
          this.indexNum = index;
          this.is_waitingEnable = item.is_waiting;
          this.is_gray_pin = item.is_gray_pin;
          this.is_inside_seller_service_area = item.is_inside_seller_service_area;
          this.is_selected_by_buyer = item.is_selected_by_buyer;
          this.is_waiting_button_enabled = item.is_waiting_button_enabled;
          if (this.newProjects.length - 1 === this.indexNum || this.indexNum === 0) {
            if (this.indexNum === 0) {
              this.isRightArrow = false;
              this.isLeftArrow = true;
            } else {
              this.isRightArrow = true;
              this.isLeftArrow = false;
            }
          }else {
            this.isRightArrow = false;
            this.isLeftArrow = false;
          }
          this.projectId = item.project_id;
          this.callProjectDetails(item.project_id);
          this.callSellersFirstDateTime(item.project_id);
          this.callBuyerInformationDetails(item.buyer_id);
          this.selectedBuyerId = item.buyer_id;
          this.buyerName = item.buyer_first_name + ' ' + item.buyer_last_name;
      }
  }

  // Change Left Move
  changeLeftMove(): void {
    this.indexNum = this.indexNum - 1;
    if (this.indexNum !== -1) {
      this.is_waitingEnable = this.newProjects[this.indexNum].is_waiting;
      this.is_gray_pin = this.newProjects[this.indexNum].is_gray_pin;
      this.is_inside_seller_service_area = this.newProjects[this.indexNum].is_inside_seller_service_area;
      this.is_selected_by_buyer = this.newProjects[this.indexNum].is_selected_by_buyer;
      this.is_waiting_button_enabled = this.newProjects[this.indexNum].is_waiting_button_enabled;
      this.projectId = this.newProjects[this.indexNum].project_id;
      this.callProjectDetails(this.newProjects[this.indexNum].project_id);
      this.callSellersFirstDateTime(this.newProjects[this.indexNum].project_id);
      this.callBuyerInformationDetails(this.newProjects[this.indexNum].buyer_id);
      this.selectedBuyerId = this.newProjects[this.indexNum].buyer_id.toString();
      this.buyerName = this.newProjects[this.indexNum].buyer_first_name + ' ' + this.newProjects[this.indexNum].buyer_last_name;
      if (this.indexNum === 0) {
        this.isRightArrow = false;
        this.isLeftArrow = true;
      }
    } else {
      this.indexNum = this.indexNum + 1;
    }
  }

  // Change Right Move
  changeRightMove(): void {
    this.indexNum = this.indexNum + 1;
    if (this.newProjects.length > this.indexNum) {
      this.is_waitingEnable = this.newProjects[this.indexNum].is_waiting;
      this.is_waitingEnable = this.newProjects[this.indexNum].is_waiting;
      this.is_gray_pin = this.newProjects[this.indexNum].is_gray_pin;
      this.is_inside_seller_service_area = this.newProjects[this.indexNum].is_inside_seller_service_area;
      this.is_selected_by_buyer = this.newProjects[this.indexNum].is_selected_by_buyer;
      this.is_waiting_button_enabled = this.newProjects[this.indexNum].is_waiting_button_enabled;
      this.projectId = this.newProjects[this.indexNum].project_id;
      this.callProjectDetails(this.newProjects[this.indexNum].project_id);
      this.callSellersFirstDateTime(this.newProjects[this.indexNum].project_id);
      this.callBuyerInformationDetails(this.newProjects[this.indexNum].buyer_id);
      this.selectedBuyerId = this.newProjects[this.indexNum].buyer_id.toString();
      this.buyerName = this.newProjects[this.indexNum].buyer_first_name + ' ' + this.newProjects[this.indexNum].buyer_last_name;
      if (this.newProjects.length - 1 === this.indexNum) {
        this.isRightArrow = true;
        this.isLeftArrow = false;
      }
    }else {
      this.indexNum = this.indexNum - 1;
    }
  }

  // Call the Project details
  callProjectDetails(projectid: Number): void {
    this.loaderActivate = true;
    this.sellerService.getProjectInformationByProjectIdandSeller(projectid.toString(), this.currentSellerName).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.projectDetails = res;
        if (this.newProjects.length === 1) {
          this.isLeftArrow = true;
          this.isRightArrow = true;
        }
      }
    }, err => {
      console.log(err);
    });
  }
  // Get the Thummail
  getFileThumail(url) {
    // tslint:disable-next-line:prefer-const
    let extension = url.split('.').splice(-1)[0].toLocaleLowerCase();
    if (extension === 'jpeg' || extension === 'png' || extension === 'gif' || extension === 'svg') {
      return url;
    }
    let mainFileType = this.sellerService.getMainFileType(extension);
    if (mainFileType == null) {
      if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
        || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
        mainFileType = 'audio';
      } else if (extension === 'flv'
        || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
        mainFileType = 'video';
      } else {
        mainFileType = 'other';
      }
      return this.sellerService.getThumbnailImages(mainFileType, url);
    }

  }

  // Call Seller First time Load the Project.. to check more Information
  callSellersFirstDateTime(projectid) {
    let safety_box_link = '';
    if (this.displayitem === 'requestome') {
      safety_box_link = environment.buyerendlink +
        '/buyer/safetybox?requestto=safetybox&requesttype=activerequest&selectedtab=summary&sellerid=' + this.currentSellerId
        + '&projectid=';
    } else {
      safety_box_link = environment.buyerendlink +
        '/buyer/safetybox?requestto=safetybox&requesttype=activerequest&selectedtab=scope&sellerid=' + this.currentSellerId
        + '&projectid=';
    }
    this.sellerService.getsellerClickFirstSeenProject(this.currentSellerId, projectid, safety_box_link).subscribe(res => {
      if (res != null) {
        // console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }

    // Convert to Number
    convertToNumber(item): Number {
      return Number(item);
    }

    // Call Buyer Information Details
    callBuyerInformationDetails(buyerid: Number): void {
      this.sellerService.getBuyerInformationByBuyerId(buyerid.toString()).subscribe(res => {
        if (res != null) {
          this.buyerInfomation = res;
          if (this.buyerInfomation.address != null) {
          // tslint:disable-next-line:prefer-const
          let addressobj = this.buyerInfomation.address.split('|');
          this.address.streetname = addressobj[0];
          this.address.city = addressobj[1];
          }
      }
      }, err => {
        console.log(err);
      });
    }

  // Accept or Declined
  acceptProjects(projectid, isaccepted): void {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.loaderActivate = true;
    $(this.openDeleteModal.nativeElement).modal('hide');
    const safety_box_link = environment.buyerendlink
    + '/buyer/safetybox?requestto=safetybox&requesttype=activerequest&selectedtab=agreement&sellerid=' + this.currentSellerId
    + '&projectid=';
    const service_request_link = environment.frontendlink +
      '/seller/browserequest?requestto=browserequest&requesttype=requestme&projectid=';
    this.sellerService.acceptRejectProjectRequest(userDetails.username, projectid,
      isaccepted, safety_box_link, service_request_link).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        this.isLeftShowHide = false;
        // if (this.displayitem === 'requestome') {
        //   this.getAllRequestmeProject();
        // } else {
        //   this.getToloadOpenRequestProjects();
        // }
        this.isLeftShowHide = false;
        if (isaccepted) {
          this.router.navigate(['seller/safetybox'],
            { queryParams: { requesttype: 'main', selectedtab: 'overview', projectid: projectid } });
        } else {
          this.router.navigate(['seller/safetybox'],
            {
              queryParams: {
                requesttype: 'archive', selectedtab: 'overview', cancellationtype: 'cancel',
                projectid: projectid
              }
            });
        }

        $(this.openDeleteModal.nativeElement).modal('hide');
      }, err => {
        console.log(err);
        this.isLeftShowHide = false;
        $(this.openDeleteModal.nativeElement).modal('hide');
      });



  }


  // Remove From waiting List
  removeFromwaitingList() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.loaderActivate = true;
    this.sellerService.removeFromWaitingListAfterAdded(userDetails.username, this.projectId).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.isLeftShowHide = false;
        if (this.displayitem === 'requestome') {
          this.getAllRequestmeProject();
        } else {
          this.getToloadOpenRequestProjects();
        }
      }
    }, err => {
      console.log(err);
    });
  }

    declineConfirmationMessage(): void {
      $(this.openDeleteModal.nativeElement).modal('hide');
    }
    confirmDeclineProject(): void {
      $(this.openDeleteModal.nativeElement).modal('show');
    }

}



// WEBPACK FOOTER //
// ./src/app/seller/browserequest/browserequest.component.ts